import styles from "./UpgradePlan.module.scss";
import CustomButton from "components/Button";
import styled from "styled-components";
import { UpgradePlanInfo } from "./UpgradePlanInfo";
import { ArrowIcon } from "./Icons";
import classNames from "classnames";
import { useSelector } from "redux/hooks";
import { RoutePaths } from "pages/routePaths";
import useRouter from "hooks/useRouter";
import { FormattedMessage } from "react-intl";
import { setUpgradeMemberModel } from "redux/actions";

const DurationButton = styled(CustomButton)`
  background-color: #5046E6;
  color: #fff;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 15px;
  font-weight: 600;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
//   transition: wdith 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   width: 48%;
  // height: 100%;

  @media (max-width: 576px) {
    font-size: 11px;
    padding: 5px 12px;
  }
  }
`;
export const UpgradePlan = () => {

    const { theme, userDetail } = useSelector((state) => state.authReducer);
    const { push } = useRouter();

    const handleUpgradeClick = () => {
        if (userDetail?.user?.team?.role === "admin" ) {
            push(`/${RoutePaths.Settings}/${RoutePaths.CurrentPlan}`)
        } else {
            setUpgradeMemberModel(true);
        }
    };
    const getFirstName = (fullName: string | undefined) => {
        if (!fullName) return "";
        return fullName.split(" ")[0];
    };
    return (
        <>
            <div className={classNames("font-inter", styles.mainContainer, {
                [styles.light]: theme === "light",
                [styles.dark]: theme === "dark"
            })}>
                <div className={styles.container1}>
                    <div className={styles.topBorder}></div>
                    <div className={styles.section1}>
                        <div className="flex gap-[8px] items-center">
                            <div className={styles.icon}>  <img
                                src={require("./upgradeIcon.png")}
                                alt="Incognito Icon"
                                className="w-6 h-6"
                            /> </div>
                            <h2 className={classNames("font-inter", styles.mainHead, {
                                [styles.light]: theme === "light",
                                [styles.dark]: theme === "dark"
                            })}>{getFirstName(userDetail?.user?.name)}, <FormattedMessage id="upgrade.head" /></h2>
                        </div>
                        <div className={classNames("font-inter", styles.subtitle, {
                            [styles.light]: theme === "light",
                            [styles.dark]: theme === "dark"
                        })}><FormattedMessage
                                id="upgrade.subtitle"
                                values={{
                                    plan:
                                        userDetail?.user?.activeSubscription?.name === "Free"
                                            ? "free"
                                            : userDetail?.user?.activeSubscription?.name === "Standard"
                                                ? "solo"
                                                : userDetail?.user?.activeSubscription?.name === "Professional"
                                                    ? "pro"
                                                    : userDetail?.user?.activeSubscription?.name === "Team"
                                                        ? "team"
                                                        : userDetail?.user?.activeSubscription?.name === "Business"
                                                            ? "enterprise" : "free",
                                }}
                            /></div>
                    </div>
                    <div className={styles.container2}>
                        <UpgradePlanInfo />
                        <div className="flex gap-[12px] flex-col w-full" onClick={handleUpgradeClick}>
                            <DurationButton
                            >
                                <span className={`font-inter ${styles.btn}`}>
                                    <FormattedMessage id="tolbar.usage.alert.btn" />
                                    <span className="leading-[0] flex-shrink-0"> <ArrowIcon /> </span>
                                </span>
                            </DurationButton>
                            <div className={classNames("font-inter", styles.footer, {
                                [styles.light]: theme === "light",
                                [styles.dark]: theme === "dark"
                            })}>
                                🔒 <FormattedMessage id="upgrade.footer" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </>
    )
}